module.exports = __webpack_public_path__ + "img/bw.d409478f.svg";